import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductionJobComponent } from './production-job/production-job.component';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '../../models/role.model';
import { ReviewSetsComponent } from './review-sets/review-sets.component';
import { ReviewTrackingComponent } from './review-tracking/review-tracking.component';
import { AiReviewComponent } from './ai-review/ai-review.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";

const discoveryRoutes: Routes = [
	{ path: 'ProductionJob', redirectTo: 'discovery/production-job', pathMatch: 'full' },
	{ path: 'production-job', redirectTo: 'discovery/production-job', pathMatch: 'full' },
	{ path: 'ProductionJob/:id', redirectTo: 'discovery/production-job/:id', pathMatch: 'full' },
	{ path: 'production-job/:id', redirectTo: 'discovery/production-job/:id', pathMatch: 'full' },
	{
		path: 'discovery',
		component: AppContainerComponent,
		children: [
			{
				path: 'production-job',
				component: ProductionJobComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			},
			{
				path: 'production-job/:id',
				component: ProductionJobComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet] }
			},
			{
				path: 'review-sets',
				component: ReviewSetsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.DocReviewFeatureSet, Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'review-tracking',
				component: ReviewTrackingComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.AccountFeatureSet, Role.Administrator] }
			},
			{
				path: 'ai-review',
				component: AiReviewComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Employee] }
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(discoveryRoutes)
	],
	exports: [
		RouterModule
	]
})
export class DiscoveryRoutingModule {
}
